/**
 * Card JoKjdQUR — Side-effect entry para el TTL cleanup del conversationId.
 *
 * Importado por ``main.tsx`` como el PRIMER import. Su top-level invoca
 * ``cleanupExpiredConversation()`` antes de que cualquier otro módulo
 * (en particular ``chatUIStore``) se evalúe, asegurando que el factory
 * de Zustand vea la key ya removida si estaba vencida.
 *
 * Está separado del módulo helper (``conversationCleanup.ts``) para que
 * los tests del helper puedan importar las funciones puras sin disparar
 * el side-effect en cada test/módulo.
 */

import { cleanupExpiredConversation } from './conversationCleanup';

cleanupExpiredConversation();
